export const getInteractionClassName = (colorPreset: string): string =>
  'interaction-part' +
  (colorPreset === 'dark'
    ? ' dark-interaction-part'
    : ' light-interaction-part');
